import { APP_CONFIG, BUY_ADD_ONS, MOBILE_SHARE, NUMBER_PORT, RECONTRACT, REPLACE_SIM, SER_ROADSHOW } from "@/config/common";

export const getDependentNames = (vasPlans, addonsList) => {
  const getNames = (plan) => {
    for (const ele of addonsList) {
      if (plan.depProductId.toString() === ele.addOnPlanId) {
        const depProductName = ele.title;
        return { ...plan, depProductName };
      }
    }
    plan['depProductName'] = '';
    return plan;
  };
  return vasPlans.map((data) => {
    return getNames(data);
  });
};

export const getCeaseVasDependentNames = (vasPlans, addonsList) => {
  const getNames = (plan) => {
    for (const ele of addonsList) {
      if (plan.depProductCode.toString() === ele.vasComponentId) {
        const depProductName = ele.componentDescription;
        return { ...plan, depProductName };
      }
    }
    plan['depProductName'] = '';
    return plan;
  };
  return vasPlans.map((data) => {
    return getNames(data);
  });
};

export const getMissingDependentsName = (plansList, depPlans) => {
  const getNames = (plans) => {
    let name = null;
    for (const ele of depPlans) {
      if (plans.depProductId.toString() !== ele.addOnPlanId) {
        name = plans.depProductName;
      }
    }
    return name;
  };
  const filteredList = plansList.map((data) => {
    return getNames(data);
  });
  return filteredList.filter((item) => item !== null);
};

export const getMissingCeaseVasDependentsName = (plansList, depPlans) => {
  const getNames = (plans) => {
    let name = null;
    for (const ele of depPlans) {
      if (plans.depPackageId.toString() !== ele.vasPackageId) {
        name = plans.depProductName;
      }
    }
    return name;
  };
  const filteredList = plansList.map((data) => {
    return getNames(data);
  });
  return filteredList.filter((item) => item !== null);
};

export const checkForDependantVAS = (vasPlans, result, addonsList) => {
  let resultData = {
    isChecked: false,
    missingNames: ''
  };
  //dependent VAS or Plan
  let dependantItemAdded = [];
  vasPlans.map((depAddon) => {
    let dependantItem = [];
    dependantItem = result.filter(
      (item) => item.addOnPlanId === depAddon.depProductId.toString()
    );
    if (dependantItem?.length > 0) {
      dependantItemAdded.push(dependantItem[0]);
    }
  });
  if (dependantItemAdded.length === vasPlans.length) {
    //all dep added
    resultData.isChecked = true;
  }
  const resArr = getDependentNames(vasPlans, addonsList);
  if (result.length >= 1) {
    const res = getMissingDependentsName(resArr, result);
    resultData.missingNames = String(res);
  } else {
    const res = resArr.map((data) => data.depProductName);
    resultData.missingNames = String(res);
  }
  return resultData;
};

export const checkCeaseVasForDependantVAS = (vasPlans, result, addonsList) => {
  let resultData = {
    isChecked: false,
    missingNames: ''
  };

  //dependent VAS or Plan
  let dependantItemAdded = [];
  vasPlans.map((depAddon) => {
    let dependantItem = [];
    dependantItem = result.filter(
      (item) => item.vasComponentId === depAddon.depProductCode.toString()
    );
    if (dependantItem?.length > 0) {
      dependantItemAdded.push(dependantItem[0]);
    }
  });

  if (dependantItemAdded.length === vasPlans.length) {
    //all dep added
    resultData.isChecked = true;
  }
  /****check removal***/
  const checkChildItemAdded: any = [];
  vasPlans.map((aeasvasPlan) => {
    addonsList.forEach((addonsListNo) => {
      if (aeasvasPlan.depProductCode === addonsListNo.vasComponentId && addonsListNo.checked === true) {
        const newItem = addonsListNo;
        checkChildItemAdded.push(newItem)
      }
    })
  })

  if (checkChildItemAdded.length === vasPlans.length) {
    //all dep added
    resultData.isChecked = true;
  }

  const resArr = getCeaseVasDependentNames(vasPlans, addonsList);

  if (result.length >= 1) {
    const res = getMissingCeaseVasDependentsName(resArr, result);
    resultData.missingNames = String(res);
  } else {
    const res = resArr.map((data) => data.depProductName);
    resultData.missingNames = String(res);
  }
  return resultData;
};

export const checkForDependantPricePlans = (pricePlans, currentPlanId) => {
  let result = false;
  pricePlans.map((depAddon) => {
    if (depAddon.depProductId.toString() !== currentPlanId) {
      result = true;
    }
  });
  return result;
};

export const getPlanByDepProductType = (crtplan, type) => {
  return crtplan.filter((data) => {
    if (data.depProductType === type) {
      return data;
    }
  });
}

export const getSimCardSVCNum = (data, currentOrder) => {

  const { simCard, serviceNumbers } = data;
  let serviceNos = serviceNumbers;

  const checkMBshare = currentOrder.cartDetails?.pricePlan?.pricePlanGroupId === APP_CONFIG.MOBILESHARE_PLAN || currentOrder.cartDetails?.pricePlan?.planTypeCode === APP_CONFIG.MOBILESHARE_PLAN_TYPE || currentOrder?.shoppingCartType === MOBILE_SHARE;
  if (checkMBshare) {
    const newsvcNo = currentOrder?.cartDetails?.serviceNumbers.filter((ele) => ele.parentMBShareNumber === true)
    serviceNos = [...newsvcNo, ...serviceNumbers];
  }

  const serviceNumberLength = currentOrder?.cartDetails?.serviceNumbers
    ? currentOrder.cartDetails.serviceNumbers.length
    : 0;
  if (currentOrder?.shoppingCartType === RECONTRACT) {
    serviceNos = currentOrder?.cartDetails?.serviceNumbers;
    simCard['quantity'] = serviceNumberLength;
  }
  if (currentOrder?.shoppingCartType === SER_ROADSHOW) {
    simCard['simCardType'] = simCard?.simCardType.replace('(on-Hand)', '');
  }
  return { simCard, serviceNos }
}

export const getNetworkType = (currentPricePlanGroupId, currentPricePlanId, cataloguePricePlan) => {

  if (currentPricePlanGroupId === 'Others') {

    const filteredMobileSharePlan = cataloguePricePlan?.length > 0 && cataloguePricePlan
      .filter((item) => item.groupId.match(APP_CONFIG.MOBILESHARE_PLAN))
    if (filteredMobileSharePlan.length > 0) {
      const filteredPricePlan = filteredMobileSharePlan[0].pricePlans.filter((item) => item.planId.includes(currentPricePlanId))
      if (filteredPricePlan.length > 0) {
        return filteredPricePlan[0]
      }
    }

  }
  return cataloguePricePlan?.length > 0 &&
    cataloguePricePlan
      .filter((item) => item.groupId.match(currentPricePlanGroupId))[0]
      .pricePlans.filter((item) => item.planId.includes(currentPricePlanId))[0];
}

export const getCurrentOrderDetails = (currentOrder, pricePlanDetails) => {
  const { serviceNumbers, simCard, addons = [], bundledAddons = [] } = currentOrder?.cartDetails || {};
  const pricePlan = currentOrder?.cartDetails?.pricePlan || {};
  const { noOfLines } = pricePlan;
  const bundledVasData = pricePlanDetails?.bundledAddons || [];
  const transactionType = currentOrder?.shoppingCartType;
  let simCardData = simCard
  if (transactionType === SER_ROADSHOW) {
    if (simCard && Object.keys(simCard).length) {
      simCardData = { ...simCardData, simCardType: `${simCardData?.simCardType}(on-Hand)` }
    }
  }
  return { serviceNumbers, simCardData, addons, noOfLines, bundledVasData, transactionType, bundledAddons }
}

export const getSimCardTypeList = (cardProfile, ORDER_TYPE) => {
  const defaultRecontractSim = ['RetainmySIM'];
  let simCardTypesList = [];
  if (cardProfile && cardProfile.length >= 1) {
    simCardTypesList = cardProfile;
  }
  const recontractSimList = defaultRecontractSim.concat(simCardTypesList);
  if (ORDER_TYPE === RECONTRACT) return recontractSimList;
  return simCardTypesList;
}

export function svcNoResetValue(serviceNumbers, shoppingCartType) {
  if ([BUY_ADD_ONS, NUMBER_PORT].includes(shoppingCartType)) return serviceNumbers;
  return [];
}

export function getActiveStep(toNextPage) {
  if (toNextPage) return 4
  return 3
}

export function getFlow(shoppingCartType) {
  const isReplaceSim = shoppingCartType === REPLACE_SIM;
  const isBuyAddons = shoppingCartType === BUY_ADD_ONS;
  return { isReplaceSim, isBuyAddons }
}

export const getAddonsPlanDetails = (addonGroup, addOnGroupId, addOnId, addOnPlanId, callBackAction) => {
  addonGroup.forEach(addGtp => {
    if (addGtp.addOnGroupId === addOnGroupId) {
      addGtp.addOns.forEach((addOn) => {
        if (addOn.addOnId === addOnId) {
          addOn.plans.forEach((plan) => {
            if (plan.addOnPlanId === addOnPlanId.toString()) {
              const tempData = {
                addOnGroupName: addGtp.name,
                addOnPlanName: plan.title,
                addOnPlanPrice: plan.price,
                oneTimeCharge: plan.oneTimeCharge
              }
              callBackAction(tempData)
            }
          })
        }
      })
    }
  })
}